<script setup>
import Popover from 'primevue/popover'
import ProductVariantThumb from '~/components/partials/subelements/ProductVariantThumb.vue'
import {cloneDeep} from 'lodash'
import Button from '~/components/common/Button.vue'
import {useNotification} from '~/composables/useNotification'


const props = defineProps({
  title: {
    type: String,
    default: 'Opciones',
  },
  helpText: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  selectedOption: {
    type: Object,
    default: () => null,
  },
  cancelTitle: {
    type: String,
    default: 'Cancelar',
  },
  selectTitle: {
    type: String,
    default: 'Seleccionar',
  }
})

const emit = defineEmits(['input'])

const notification = useNotification()
const selectedItem = ref(null)
const internalOptions = ref([])
const popoverRef = ref(null)

function onMarkItem(data) {
  selectedItem.value = data
}

function onSelectItem() {
  if (!selectedItem.value) {
    return notification.showError('Debes seleccionar una opción.')
  }
  emit('input', cloneDeep(selectedItem.value))
  popoverRef.value.hide()
}

function open($event) {
  popoverRef.value.show($event)
}

function close() {
  popoverRef.value.hide()
  selectedItem.value = null
}

function getOptionIsSelected(id) {
  return selectedItem.value?.id === id
}

watch(() => props.options, () => {
  internalOptions.value = [...props.options].sort((a, b) => a.price - b.price)
}, {immediate: true})

watch(() => props.selectedOption, (newVal) => {
  selectedItem.value = cloneDeep(newVal)
}, {immediate: true})

defineExpose({
  open,
})
</script>

<template>
  <Popover ref="popoverRef">
    <div class="flex flex-col gap-4 w-[25rem]">
      <div>
        <span class="uppercase block mb-2 bg-white text-[#363330] text-center">{{ props.title }}</span>
        <ul class="grid grid-cols-12 gap-2">
          <ProductVariantThumb
            v-for="option in internalOptions"
            class="col-span-3 hover:font-bold hover:text-red-800"
            :selected="getOptionIsSelected(option.id)"
            :key="option.id"
            :data="option"
            @click="onMarkItem"
          />
        </ul>
        <p v-if="props.helpText" class="text-xs font-bold italic text-red-800">{{ props.helpText }}</p>
      </div>
      <div class="mt-2 flex gap-2 justify-center sm:justify-between">
        <Button
          @click="close"
          severity="tertiary"
          :label="props.cancelTitle"
        />
        <Button
          @click="onSelectItem"
          :label="props.selectTitle"
          severity="primary"
        />
      </div>
    </div>
  </Popover>
</template>
